var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdditionalGuidance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19.5C4.76168 19.5 0.5 15.2383 0.5 10C0.5 4.76168 4.76168 0.5 10 0.5C15.2383 0.5 19.5 4.76168 19.5 10C19.5 15.2383 15.2383 19.5 10 19.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1C5.03738 1 1 5.03738 1 10C1 14.9626 5.03738 19 10 19C14.9626 19 19 14.9626 19 10C19 5.03738 14.9626 1 10 1ZM10 0C15.5229 0 20 4.47715 20 10C20 15.5229 15.5229 20 10 20C4.47715 20 0 15.5229 0 10C0 4.47715 4.47715 0 10 0Z",
    fill: "#DD3926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79303 15.159V4.53799H11.172L13.993 7.04999V15.159H5.79303ZM7.16003 13.045H12.627V12.169H7.16003V13.045ZM7.16003 11.215H12.627V10.338H7.16003V11.215ZM7.16003 9.38499H10.104V8.50799H7.16003V9.38499Z",
    fill: "white",
    stroke: "#DD3926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75201 4.49699V15.197H14.035V7.03099L11.186 4.49699H5.75201Z",
    fill: "white",
    stroke: "#DD3926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10H12.7V11H7V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10H12.6958V11H7V10Z",
    fill: "#DD3926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8H9.689V9H7V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8H9.68896V9H7V8Z",
    fill: "#DD3926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12H12.7V13H7V12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12H12.6958V13H7V12Z",
    fill: "#DD3926"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalGuidance);
export default __webpack_public_path__ + "static/media/additional-guidance.11a73b33b65ef9cc37e7f0e28782abba.svg";
export { ForwardRef as ReactComponent };